import React, { useState } from "react";
import { CgClose } from "react-icons/cg";
import OTPInput from "react-otp-input";
import axios from "axios";
import { CryptoState } from "./FarmerContext";
import Swal from "sweetalert2";
import { Spinner } from "react-bootstrap";

const AadharVerification = ({ SetAadharModal, clientId, sendOtp }) => {
  const { setAadharVerified } = CryptoState();
  var userId = localStorage.getItem("user-info-id");
  let user_token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);

  const Api_Url = process.env.REACT_APP_API_URL;

  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");

  const handleChange = (value) => {
    setOtp(value);
    if (value.length === 6) setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (otp.length !== 6 || !/^\d{6}$/.test(otp)) {
      setError("Please enter a valid 6-digit OTP.");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        otp: otp,
        client_id: clientId,
        applicant_id: userId,
        created_by: "0",
      };

      const response = await axios.post(
        `${Api_Url}/api/aadhaar/verify-otp/`,
        payload,
        {
          headers: { Authentication: `Token ${user_token}` },
        }
      );

      if (response.status === 200 || response.data === true) {
        Swal.fire(response?.data?.message);
        setAadharVerified(true);
        SetAadharModal(false);
      }
    } catch (err) {
      Swal.fire(err?.response?.data?.message);
      setError("OTP verification failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 position-relative">
      <CgClose
        className="position-absolute cursor"
        onClick={() => SetAadharModal(false)}
        style={{ fontSize: "22px", top: "10px", right: "10px" }}
      />

      <div className="d-flex justify-content-center align-items-center flex-column py-3">
        <h3>Verify</h3>
        <p>Enter the OTP sent to your registered Mobile No.</p>

        <form className="d-flex flex-column gap-4 py-3 justify-content-center align-items-center">
          <div className="mb-3">
            <OTPInput
              type="number"
              value={otp}
              name="otp_code"
              inputStyle="inputStyle2"
              numInputs={6}
              onChange={handleChange}
              separator={<span></span>}
            />
          </div>

          {error && <p className="m input-error text-danger">{error}</p>}

          <button
            type="button"
            className="verify_btn"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? <Spinner size="sm"></Spinner> : "Verify"}
          </button>
        </form>

        <p className="mt-3">
          Didn't get the OTP?{" "}
          <span
            className="text-primary text-underline cursor"
            onClick={sendOtp}
          >
            Request Again
          </span>
        </p>
      </div>
    </div>
  );
};

export default AadharVerification;
